// QR Kiosk v2 — press-feedback hook (relocated from dashboard/kioskLiveStatus.ts
// in KV2-4 because it is now shared across the dashboard AND the reference pages).
// Mirrors the committed AccountSheet `SheetRow` pattern (local state toggled on
// pointer/mouse down+up / enter+leave) to reproduce v1's `:active { transform:
// scale(0.98) }`. A shared PressableCard component is deliberately NOT built.
import React from "react";

export function usePressed() {
  const [pressed, setPressed] = React.useState(false);
  const pressHandlers = {
    onPointerDown: () => setPressed(true),
    onPointerUp: () => setPressed(false),
    onMouseEnter: () => setPressed(true),
    onMouseLeave: () => setPressed(false),
  };
  const pressStyle: React.CSSProperties = {
    transform: pressed ? "scale(0.98)" : "none",
    transition: "transform .12s",
  };
  return { pressed, pressHandlers, pressStyle };
}
